export enum StatusChipType {
  Failed = 'failed',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Sync = 'sync',
}
